<div [class.setting]="setting"
     class="app-header"
     *ngIf="!HideHeader"
     [class.backgroundWhite]="isBackgroundWhite">
  <ion-icon *ngIf="showBackArrow" name="arrow-back-outline" (click)="onBack()" class="back-icon"></ion-icon>
  <h5>{{pageTitle}}</h5>
  <div *ngIf="showPrint" (click)="onPrint()" class="print-section">
    <span style="font-size: 14px;font-weight: 400;" class="print-order">Print</span>
    <ion-icon name="print" class="print-order" fill="outline" color="white" style="font-size: 20px;"></ion-icon>
  </div>
</div>
